// extracted by mini-css-extract-plugin
export default {"inputField":"select_inputField__7Czhu"};